import {
	DriftWalletName,
	DRIFT_CUSTOM_WALLET_OPTIONS,
	DRIFT_CUSTOM_WALLET_ICONS,
} from 'src/constants/wallets';
import { WALLET_BUTTON_CLASSNAME } from './WalletButton';

export const MagicLinkButton = (props: {
	onChooseWallet: (walletName: DriftWalletName) => void;
}) => {
	return (
		<button
			onClick={() =>
				props.onChooseWallet(
					DRIFT_CUSTOM_WALLET_OPTIONS.MAGIC_AUTH_WALLET_ADAPTER_NAME
				)
			}
			className={WALLET_BUTTON_CLASSNAME}
		>
			<div className="flex items-center">
				<div className="mr-4 size-6">
					<img
						src={DRIFT_CUSTOM_WALLET_ICONS.MAGIC_AUTH_WALLET_ADAPTER}
						className="size-full"
					/>
				</div>
				<div className="text-left text-text-default">Email via Magic Link</div>
			</div>
		</button>
	);
};
